import { createContext } from 'react'

const ReferenceDataContext = createContext(null)

export default ReferenceDataContext
